

















































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { IRequisition, IUser } from '@/models';
import EmployeeUserPicker from '../employee/EmployeeUserPicker.vue';

export default Vue.extend({
  name: 'RequisitionOwnerListMenu',

  components: { EmployeeUserPicker },

  props: {
    requisition: {
      type: Object as () => IRequisition,
      required: true
    },
    disabled: Boolean
  },

  data() {
    return {
      ownerLoading: false,
      ownerDialog: false,
      errorMessage: '',
      owner: null as null | number
    };
  },

  watch: {
    ownerDialog(value: boolean) {
      if (value) {
        if (this.requisition.owner) {
          this.owner =
            (this.requisition.owner as IUser).id ??
            (this.requisition.owner as number);
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateRequisitionOwner: 'requisition/updateRequisitionOwner'
    }),

    closeDialog() {
      this.errorMessage = '';
      this.ownerLoading = false;
      this.ownerDialog = false;
    },

    async setRequisitionOwner(owner: number) {
      this.ownerLoading = true;
      await this.updateRequisitionOwner({
        requisitionId: this.requisition.id,
        owner
      })
        .then(() => {
          this.closeDialog();
        })
        .catch(() => {
          this.errorMessage = 'Error assigning owner';
          this.ownerLoading = false;
        });
    }
  }
});
